import { render, staticRenderFns } from "./top-c.vue?vue&type=template&id=23bd328a&scoped=true&"
import script from "./top-c.vue?vue&type=script&lang=js&"
export * from "./top-c.vue?vue&type=script&lang=js&"
import style0 from "./top-c.vue?vue&type=style&index=0&id=23bd328a&prod&scoped=true&lang=css&"
import style1 from "./top-c.vue?vue&type=style&index=1&id=23bd328a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd328a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContent,VOverlay,VProgressCircular,VRow})
